import { Component, OnInit, OnDestroy,Output,EventEmitter } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'smart-app-banner',
  templateUrl: './smart-app-banner.component.html',
  styleUrls: ['./smart-app-banner.component.scss']
})

export class SmartAppBannerComponent {
  @Output() updateShowBanner = new EventEmitter();
  description = 'For the best drafting experience';
  showSmartBanner =false;
  deviceType ='';
  downloadText ='View';
  constructor(private deviceService: DeviceDetectorService) {
  this.deviceType = this.deviceService.os;
  }


  ngOnInit() {

  }

  ngOnDestroy() {

  }

  closeSmartAppPopup(){
    this.showSmartBanner = false;
    this.updateShowBanner.emit(this.showSmartBanner);
  }
  installApp(){
    // setTimeout(function () { 
    //   window.location.href = "itms-appss://apps.apple.com/us/app/drafters-fantasy-sports/id1273975920"; 
    // }, 25);
    // window.location.href = "draftersapp://"; 

    var app = {
      launchApp: function() {
      //  window.location.href = "draftersapp://";
        this.timer = setTimeout(this.openWebApp, 1000);
      },
  
      openWebApp: function() { 
        window.location.href = "http://apps.apple.com/us/app/drafters-fantasy-sports/id1273975920/";
      }
    };
  
    app.launchApp();

  }
}
